import { render, staticRenderFns } from "./TheDesktopNavigationItem.vue?vue&type=template&id=c08f6dc8"
import script from "./TheDesktopNavigationItem.vue?vue&type=script&lang=js"
export * from "./TheDesktopNavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports